const customDomainMappings = Object.freeze({
  localhost: "",
  "belongingcenter.ukg.com": "https://ukg.communitycliq.com",
  "inclusionnetwork.jnj.com": "https://jnj.communitycliq.com",
});

let fqdn;
if (
  customDomainMappings[window.location.hostname.toLowerCase()] === undefined
) {
  const port = window.location.port ? `:${window.location.port}` : "";
  fqdn = `${window.location.protocol}//${window.location.hostname}${port}`;
} else {
  fqdn = customDomainMappings[window.location.hostname.toLowerCase()];
}

export const config = {
  apiUrl: fqdn
    .replace("diverst.com", "api.diverst.com")
    .replace("communitycliq.com", "api.communitycliq.com"),
  environment: process.env.ENVIRONMENT,
  weglotKey: process.env.WEGLOT_KEY,
  sentryDsn: process.env.SENTRY_DSN,
  revision: process.env.REVISION || "development",
  metabase_url: process.env.METABASE_URL || "http://localhost:7600",
  slackClientId: process.env.SLACK_CLIENT_ID,
  learningLabApiUrl: `${process.env.LEARNING_LAB_API_URL}/api/v1`,
  roiSuiteApiUrl: `${process.env.ROI_SUITE_API_URL}/api/v1`,
  // When true, /login hands authentication to Zitadel instead of showing a credential form.
  // The redirect targets the backend, which holds the PKCE verifier and the client secret.
  cliqIamEnabled: process.env.CLIQ_IAM_ENABLED === "true",
  // CliQIn, the dashboard that spans both products. Empty hides the link entirely, so an
  // environment without a CliQIn deployment simply doesn't offer one.
  cliqInUrl: process.env.CLIQIN_URL || "",
};

export const context_root = "/api/v1";

export default config;
